/**
 * Coffee Drop Section - Scroll Animations
 * Handles fade-in animations for headings and coffee drop image
 */

class CoffeeDropSection extends HTMLElement {
  constructor() {
    super();
    this.animationsEnabled = this.dataset.enableAnimations === 'true';
  }

  connectedCallback() {
    if (this.animationsEnabled) {
      this.init();
    } else {
      // If animations disabled, make everything visible immediately
      this.querySelectorAll('.coffee-drop__heading, .coffee-drop__image').forEach(el => {
        el.classList.add('visible');
      });
    }

    // Populate wavy text paths
    this.populateWavyText();
  }

  init() {
    this.setupHeadingAnimations();
    this.setupCoffeeDropAnimation();
  }

  setupHeadingAnimations() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.4 }
    );

    this.querySelectorAll('.coffee-drop__heading').forEach((heading) => {
      observer.observe(heading);
    });
  }

  setupCoffeeDropAnimation() {
    const drop = this.querySelector('.coffee-drop__image');
    if (!drop) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { rootMargin: '0px 0px -50% 0px', threshold: 0 }
    );

    observer.observe(drop);
  }

  populateWavyText() {
    const wavyText = this.dataset.wavyText || "LET'S GET CAFFEINATED";
    const repeatedText = (wavyText + ' • ').repeat(10);

    this.querySelectorAll('.coffee-drop__wavy-textpath').forEach((textPath) => {
      textPath.textContent = repeatedText;
    });
  }
}

customElements.define('coffee-drop-section', CoffeeDropSection);
